import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderFilledSvg from "@ant-design/icons-svg/es/asn/FolderFilled";
import AntdIcon from '../components/AntdIcon';
var FolderFilled = function FolderFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FolderFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FolderFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FolderFilled';
}
export default RefIcon;